$(document).ready(function() {
    $(document).on("change", ".product-form__input input[type=radio]", function() {
        var e = $(this).next("label").data("src");
        $(".product__media-wrapper .slider-for-wrappper figure img").attr("src", e), console.log(e)
    })
}), $(document).ready(function() {
    $(".owl-carousel").owlCarousel({
        items: 8,
        loop: !0,
        margin: 20,
        autoplay: !0,
        slideTransition: "linear",
        autoplayTimeout: 0,
        autoplaySpeed: 3e3,
        autoplayHoverPause: !1
    })
}), $(".js-banner-slider").slick({
    dots: !1,
    arrows: !1,
    infinite: !0,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !0,
    cssEase: "linear",
    variableWidth: !0,
    pauseOnHover: !1,
    pauseOnFocus: !1,
    autoplaySpeed: 0,
    speed: 2e3
}), $(document).ready(function() {
    function e() {
        window.innerWidth <= 991 ? ($(".footer-block--menu .footer-block__details-content").hide(), $(".footer-block--menu .footer-block__heading").off("click").on("click", function() {
            var e = $(this);
            e.hasClass("active") ? (e.removeClass("active"), e.siblings(".footer-block__details-content").slideUp(200)) : ($(".footer-block--menu .footer-block__heading").removeClass("active"), $(".footer-block--menu .footer-block__details-content").slideUp(200), e.addClass("active"), e.siblings(".footer-block--menu .footer-block__details-content").slideDown(200))
        })) : ($(".footer-block--menu .footer-block__details-content").show(), $(".footer-block--menu .footer-block__heading").off("click"))
    }
    e(), $(window).resize(function() {
        e()
    })
});
var swiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: !0
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});

function BannerMarginTop() {
    let e = $(".shopify-section.section-header").outerHeight();
    $("body.home-page ").css("margin-top", e + "px"), console.log(`Header height: ${e}px`)
}


function setBlogDetailsMarginTop() {
    let e = $(".shopify-section.section-header").outerHeight();
    $(".policy-content").css("margin-top", e + "px"), console.log(`Header height: ${e}px`)
}
function seterror() {
    let e = $(".shopify-section.section-header").outerHeight();
    $(".template-404").css("margin-top", e + "px"), console.log(`Header height: ${e}px`)
}
function setBlogBannerMarginTop() {
    let e = $(".shopify-section.section-header").outerHeight();
    $(".blog-details-section").css("margin-top", e + "px"), console.log(`Header height: ${e}px`)
}

function faqMarginTop() {
    if (window.innerWidth <= 767) {
        let e = $(".shopify-section.section-header").outerHeight();
        $(".faq_banner_sec, .contact-page-banner").css("margin-top", e + "px"), console.log(`Header height: ${e}px`)
    } else $(".faq_banner_sec, .contact-page-banner").css("margin-top", "")
}

function policypaddingtop() {
    let e = $(".shopify-section.section-header").outerHeight();
    $(".shopify-policy__container").css("padding-top", e + "px"), console.log(`Header height: ${e}px`)
}
swiper = new Swiper(".bestseller", {
    slidesPerView: "auto",
    spaceBetween: 30,
    slidesPerGroupSkip: 3,
    centeredSlides: !0,
    loop: !0,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
}), $(document).ready(function() {
    BannerMarginTop(), setBlogDetailsMarginTop(), policypaddingtop(), faqMarginTop(), setBlogBannerMarginTop(), seterror()
}), $(window).resize(function() {
    BannerMarginTop(), setBlogDetailsMarginTop(), policypaddingtop(), faqMarginTop(), setBlogBannerMarginTop(), seterror()
}), $(document).ready(function() {
    $(".galleySwiper-wrapper").slick({
        dots: !1,
        arrows: !1,
        infinite: !0,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: !0,
        autoplaySpeed: 0,
        speed: 2e3,
        cssEase: "linear",
        variableWidth: !0,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        }]
    }), $(".slider-for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !1,
        dots: !1,
        asNavFor: ".slider-nav",
        infinite: !1,
        dots: !1,
        prevArrow: '<button class="slick-prev slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.46967 5.47028C0.176777 5.76317 0.176777 6.23805 0.46967 6.53094L5.24264 11.3039C5.53553 11.5968 6.01041 11.5968 6.3033 11.3039C6.59619 11.011 6.59619 10.5361 6.3033 10.2433L2.06066 6.00061L6.3033 1.75797C6.59619 1.46508 6.59619 0.990203 6.3033 0.697309C6.01041 0.404416 5.53553 0.404416 5.24264 0.697309L0.46967 5.47028ZM1 6.75061L16 6.75061V5.25061L1 5.25061L1 6.75061Z" fill="black"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5303 6.53094C15.8232 6.23805 15.8232 5.76317 15.5303 5.47028L10.7574 0.69731C10.4645 0.404416 9.98959 0.404417 9.6967 0.69731C9.40381 0.990203 9.40381 1.46508 9.6967 1.75797L13.9393 6.00061L9.6967 10.2433C9.40381 10.5361 9.40381 11.011 9.6967 11.3039C9.98959 11.5968 10.4645 11.5968 10.7574 11.3039L15.5303 6.53094ZM15 5.25061L-6.55671e-08 5.25061L6.55671e-08 6.75061L15 6.75061L15 5.25061Z" fill="#000"/></svg></button>',
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: !1
            }
        }]
    }), $(".slider-nav").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: !1,
        arrows: !1,
        focusOnSelect: !0,
        verticalSwiping: !0,
        vertical: !0,
        infinite: !1,
        prevArrow: "<button type='button' class='slick-prev icon-angle-left'><img src=\"https://cdn.shopify.com/s/files/1/0255/1729/3613/files/left-arrow-slider.png?v=1719384457\"></button>",
        nextArrow: "<button type='button' class='slick-next icon-angle-right'><img src=\"https://cdn.shopify.com/s/files/1/0255/1729/3613/files/right-arrow-slider.png?v=1719384548\"></button>",
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: !1,
                verticalSwiping: !1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                vertical: !1,
                verticalSwiping: !1
            }
        }]
    })
}), $(document).ready(function() {
    chatinterval = setInterval(function() {
        var e = $(".related-products ul").length;
        console.log(e), e >= 1 && (console.log("Apply Slider"), $(".related-products .product-grid").slick({
            dots: !1,
            infinite: !0,
            speed: 300,
            slidesToShow: 3,
            arrows: !0,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: !1,
                    verticalSwiping: !1
                }
            }]
        }), clearInterval(chatinterval))
    }, 1e3)
}), $(function() {
    $(".accordion__title").on("click", function() {
        var e = $(this);
        e.hasClass("accordion-active") || ($(".accordion__content").slideUp(), $(".accordion__item").removeClass("accoridan-wrapper__active"), $(".accordion__title").removeClass("accordion-active"), $(".accordion__arrow").removeClass("accordion__rotate")), e.toggleClass("accordion-active"), $(this).parent().toggleClass("accoridan-wrapper__active"), e.next().slideToggle(), $(".accordion__arrow", this).toggleClass("accordion__rotate")
    })
}), $(window).on("load", function() {
    setTimeout(function() {
        $(".page-loader").fadeOut("fast")
    }, 500)
});
jQuery('.icon-marquee-carousel').owlCarousel({
            center: true,
            autoWidth:true,
            items:8,
            loop:true,
            margin:20,
            nav:false,
            dots:false,
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout: 2000,
            autoplaySpeed: 2000,
            autoplayHoverPause: false,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:5
                },
                1000:{
                    items:5
                }
            }
        });